var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ListComponent',{ref:"list",attrs:{"api-route":"invoices","favourites-key":'agency-receipts',"filter-options":_vm.filterOptions,"available-columns":_vm.availableColumns,"default-columns":_vm.defaultColumns,"actions":_vm.actions,"query-params":_vm.queryParams}})
}
var staticRenderFns = []

export { render, staticRenderFns }